import { gql } from "@apollo/client";

export const GET_API_KEYS = gql`
  query {
    apiKeys {
      id
      key
      name
      scopes
      isActive
      createdAt
      lastUsedAt
    }
  }
`;
